export type SeuPagination = {
  currentPage: number;
  itemsPerPage: SeuItemsPerPage;
  totalItems: number;
};

export type SeuItemsPerPage = 6 | 10 | 20 | 30 | 100;
export const SEU_PAGINATION_ITEMS_PER_PAGE: SeuItemsPerPage[] = [
  6, 10, 20, 30, 100,
];
export const SEU_PAGINATION_DEFAULT_ITEMS_PER_PAGE: SeuItemsPerPage = 6;
